<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요.
  - 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다
  - 해당 팝업은 MO에서는 풀로 나오는 형태라 type-mo-full 클래스 추가해주셔야합니다.
-->
  <AbstractPop :type-mo-full="true">
    <div class="dialog type-filter">
      <header class="dialog-header">
        <h2>
          <span class="sr-only">매입현황 상세보기 팝업</span>
        </h2>
        <button type="button" class="dialog-close" @click="() => emit('close')">
          <span class="c-icon icon-large-x"></span>
          <span class="sr-only">팝업 닫기</span>
        </button>
      </header>

      <div class="dialog-content">
        <div class="dialog-content-inner">
          <h3 class="c-title-level3 only-mo">매입현황 상세보기</h3>
          <div class="mo-order-detail-wrap">
            <div class="c-table-horizontal">
              <table>
                <caption>
                  매입현황 상세보기 테이블
                </caption>
                <colgroup>
                  <col style="width: 120px" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">매입일자</th>
                    <td>{{ item.prsdt }}</td>
                  </tr>
                  <tr>
                    <th scope="row">지점/영업소</th>
                    <td>{{ item.zdeptName }}</td>
                  </tr>
                  <tr>
                    <th scope="row">제품코드</th>
                    <td>{{ item.matnr }}</td>
                  </tr>
                  <tr>
                    <th scope="row">제품명</th>
                    <td>{{ item.zzmaktx }}ㄴ</td>
                  </tr>
                  <tr>
                    <th scope="row">유형</th>
                    <td>{{ item.prodht }}</td>
                  </tr>
                  <tr>
                    <th scope="row">규격</th>
                    <td>{{ item.zztotalQty }}</td>
                  </tr>
                  <tr>
                    <th scope="row">매입수량</th>
                    <td>{{ Number(item.kwmeng) }}</td>
                  </tr>
                  <tr>
                    <th scope="row">단가</th>
                    <td>{{ Number(item.netpr).toLocaleString() }}</td>
                  </tr>
                  <tr>
                    <th scope="row">매입금액</th>
                    <td>{{ Number(item.netwr).toLocaleString() }}</td>
                  </tr>
                  <tr>
                    <th scope="row">배송지</th>
                    <td>
                      <template
                        v-if="
                          item.dlvMthdCd == 10 ||
                          item.dlvMthdCd == 15 ||
                          item.dlvMthdCd == 25
                        "
                      >
                        {{ item.addr }}
                      </template>
                      <template v-if="item.dlvMthdCd == 20">
                        {{ item.dlvBranchCd }}
                      </template>
                      <template v-if="item.dlvMthdCd == 30">
                        {{ Utils.replace(item.namePlant, "노루페인트", "") }}
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AbstractPop>
</template>
<script setup name="moPurcharseListDetail">
import { defineProps, defineEmits, ref } from "vue";
import AbstractPop from "../common/AbstractPop.vue";
import Utils from "@/js/utils";

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const item = ref(props.item);
const emit = defineEmits(["close"]);
</script>
